export default (callback: (...params: any) => void, delay: number = 100) => {
  let waiting = false
  return function (...args: any) {
    if (!waiting) {
      waiting = true
      // We know this works and have tests around it, but it is tricky
      // to satisfy the TS compiler when using apply
      // @ts-ignore
      callback.apply(this, args)
      setTimeout(() => (waiting = false), delay)
    }
  }
}
